<template>
  <div>
    <populate-form
      formTitle="店家劃位歷史紀錄處理"
      fkey="rhm01"
      ref="filterStoreForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      :validatePrompt="false"
      :parentVue="this"
      @customValueChanged="filterChanged"
    ></populate-form>
    <b-table
      :items="reservation_histories"
      :fields="fields"
      stacked="sm"
    >
      <template v-slot:cell(reserve_type)="row">
        <!--外部分類名稱或票券課程名稱-->
        {{row.item.reserve_type==='s99_ticket'?row.item.ticket_project_name:row.item.ext_src_type_name}}
      </template>
      <template v-slot:cell(reserve_time)="row">
        <!--把劃位起訖時間把秒截掉黏在一起顯示-->
        {{row.item.reserve_start_time.substr(0,16)+'~'+row.item.reserve_end_time.substr(11,5)}}
      </template>
      <template v-slot:cell(reserve_info)="row">
        <!--s99票券顯示劃位消費者名字,自訂劃位顯示店家自己key的備註-->
        {{row.item.reserve_type==='s99_ticket'?row.item.reserve_user_name:row.item.reserve_remark}}
      </template>
      <template v-slot:cell(status)="row">
        <!--已履約/已過期/已取消-->
        {{textMap.close_status[row.item.close_status]}}
        {{row.item.close_status==='cancelled'?('('+textMap.cancel_status[row.item.cancel_status]+')'):''}}
        {{row.item.close_status==='expired'?('('+textMap.expire_type[row.item.expired_type]+')'):''}}
      </template>
      <template v-slot:cell(actions)="row">
        <b-button v-if="row.item.close_status==='expired'&&row.item.reserve_type==='s99_ticket'&&row.item.expired_type==='user_bird_store'" @click="showConfirmBird(row.item)">確認店家爽約</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>


export default {
  name: 'StoreRsvHisManage',
  components: {
    
  },
  data: function () {
    return {
      Stores:[],
      modalConfirmShow:false,
      reservation_histories:[],
      fields:[
        {
          key:'reserve_type',
          label:'類型',//外部或s99_ticket兩種,用template欄位顯示(外)自訂類型或課程名稱
          thStyle: {width:'20vw'}
        },
        {
          key:'reserve_time',
          label:"劃位時間",//也用template欄位把起訖時間組成一個字串顯示
        },
        {
          key:'reserve_time',
          label:'劃位於'
        },
        {
          key:'reserve_info',
          label:'劃位資訊',//s99_ticket是會員姓名,外部劃位則是店家劃位備註欄位
        },
        {
          key:'status',
          label:'狀態',//狀態用close_status翻譯成template欄位顯示
        },
        {
          key:'actions',
          label:'操作'
        }
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'vue-single-select',
          optionVar:'Stores',
          asyncFetchCB: this.loadStoreByKeyword,
          defaultValue:null,
          akey:'SelectedStoreItem',
          optionLabel:'select_text',
          col:12,
          placeholder:'選擇店家(輸入至少一個字的店家名稱關鍵字或SPS編號帶出選項,按Esc可清除全部關鍵字)',
        },
        {
          componentType:'date-picker',
          akey:'filter_date_s',
          col:3,
          placeholder:'篩選劃位日期-起',
        },
        {
          componentType:'date-picker',
          akey:'filter_date_e',
          col:3,
          placeholder:'篩選劃位日期-迄',
        },
        {
          componentType:'text',
          akey:'keyword',
          col:3,
          placeholder:'篩選劃位者姓名或劃位備註',
          execCallback:this.getHisData
        }

      ],
      birdData:{},
      birdOptions:[

      ],
      textMap:{
        close_status:{
          'expired':'已過期',
          'executed':'已履約',
          'cancelled':'已取消',
          'cancelled_after_excuted':'被後台手動取消'
        },
        expire_type:{
          'user_bird_store':'用戶爽約',
          'private_reserve_expire':'自訂劃位',
          'cancel_deal':'事後合意取消',
          'support_confirm_store_bird_user':'客服確認店家爽約',
          '':'未定義'
        },
        cancel_status:{
          'in_harmony':'合意取消',
          'in_peace':'一般爽約',
          'in_trouble':'衝突爽約'
        }
      }
    }
  },
  methods: {
    filterChanged(upd) {
      if (upd.key === 'SelectedStoreItem') {
        if (upd.val) {
          this.getHisData()
        }
        else {
          this.reservation_histories = []
        }
      }
      else if (['filter_date_s','filter_date_e'].includes(upd.key) && this.filterData.SelectedStoreItem) {
        this.getHisData()
      }
    },
    showConfirmBird(item) {
      this.$bus.fnShowConfirm("是否確認更新為店家對用戶爽約?", ()=>{
        let Param = {
          module:'store_admin',
          method:'confirmStoreBirdUser',
          history_id:item.store_reservation_result_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnClosePopup()
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.getHisData()
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo("更新完成")
        },this)
      })

      
    },
    getHisData() {
      if (!this.filterData.SelectedStoreItem) {
        this.$bus.fnShowInfo("請先選擇店家")
        return
      }
      let Param = {
        module:'store_admin',
        method:'getStoreReservationHistoryList',
        store_id:this.filterData.SelectedStoreItem.id,
        keyword:this.filterData.keyword,
        filter_date_s:this.filterData.filter_date_s?this.filterData.filter_date_s:'',
        filter_date_e:this.filterData.filter_date_e?this.filterData.filter_date_e:'',
        page_number:1,
        items_per_page:500,
        include_normal_cancelled:0,
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.reservation_histories = data.data
      }, this)

    },
    loadStoreByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Stores = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getStoreAutoComplete',
        'keyword':keyword,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Stores = data.data.matched_store_list
      },this)
    },
    /*getStatusText(item) {
      let status_m = ""
      let status_d = ""
      switch (item.close_status) {
        case 'executed':
          status_m = "已履約"
          break
        case 'expired':
          status_m = '已過期'
          break
        case 'cancelled':
          status_m = '已取消'
          break
      }
      if (status_m === '已過期') {

      }
      else if (status_m === '已取消') {

      }
      
    },*/
  },
  computed:{
    
  },
  created () {
    
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
